<h3>ポップアップウィンドウを生成しデータのやり取りを行うサンプル</h3>

<br />
&nbsp;
<button
  type="button"
  class="btn btn-sm btn-primary"
  (click)="openComponentWindow()"
>
  Open Window(angular)
</button>
&nbsp;
<button type="button" class="btn btn-sm btn-success" (click)="openWindow()">
  Open Window(pure javascript)
</button>
<br />
<br />
&nbsp;
<button type="button" class="btn btn-sm btn-warning" (click)="closeWindow()">
  Close Window
</button>

<br />
<br />
テキスト
<input
  type="text"
  class="input input-sm"
  (ngModelChange)="onChangeText($event)"
  [(ngModel)]="inputText"
/>
<br />
